<template>
  <div v-if="isAccess">
    <!-- включает анкету ПД -->
    <BaseSwitcher
      :value="getPDEnabled"
      :disabled="!abilities.canEditFksPdFields"
      @input="handlePDSettingsToggle"
    >
      <template slot="label">
        {{ $t('tournaments.settings_pd-toggler') }}
        <pvp-tooltip>
          <Icon name="info" inline />
          <template slot="tooltip">
            {{ $t('tournaments.settings_pd-toggler-tooltip') }}
          </template>
        </pvp-tooltip>
      </template>
    </BaseSwitcher>
    <!-- настройки анкеты ПД -->
    <template v-if="getPDEnabled">
      <!-- минимальный возраст -->
      <div class="inline-group">
        <BaseInput
          :value="form.fksPdV2Settings.value.minAge"
          :label="$t('tournaments.settings_age-input-label')"
          :placeholder="
            $t('tournaments.settings_age-input-placeholder')
          "
          @input="handleMinAgeInput"
        />
        <pvp-tooltip class="left">
          <Icon name="info" inline />
          <template slot="tooltip">
            {{ $t('tournaments.settings_age-input-tooltip') }}
          </template>
        </pvp-tooltip>
      </div>

      <!--  Запрашивать регион при регистрации -->
      <BaseSwitcher
        :value="isRegionRequired"
        @input="handleRegionRequiredToggle"
      >
        <template slot="label">
          {{ $t('tournaments.settings_region-required-label') }}
          <pvp-tooltip>
            <Icon name="info" inline />
            <template slot="tooltip">
              {{ $t('tournaments.settings_region-required-tooltip') }}
            </template>
          </pvp-tooltip>
        </template>
      </BaseSwitcher>

      <!-- Ограничение по региону -->
      <BaseSwitcher
        :value="isRegionRestrictionEnabled"
        @input="handleAllowedRegionToogle"
      >
        <template slot="label">
          {{
            $t('tournaments.settings_allowed-region-toggler-label')
          }}
          <pvp-tooltip>
            <Icon name="info" inline />
            <template slot="tooltip">
              {{
                $t(
                  'tournaments.settings_allowed-region-toggler-tooltip',
                )
              }}
            </template>
          </pvp-tooltip>
        </template>
      </BaseSwitcher>
      <div v-if="isRegionRestrictionEnabled" class="pd indent">
        <div class="pd-label">
          {{ $t('tournaments.settings_allowed-region-select-label') }}
        </div>
        <BaseSelect
          class="settings-control"
          :placeholder="
            form.fksPdV2Settings.value.allowedRfRegionIds?.length
              ? ''
              : $t(
                  'tournaments.settings_allowed-region-select-placeholder',
                )
          "
          :multiple="true"
          value-key="id"
          label-key="name"
          :options="regions"
          :value="form.fksPdV2Settings.value.allowedRfRegionIds"
          @input="
            updateFormData({
              name: form.fksPdV2Settings.name,
              value: {
                ...form.fksPdV2Settings.value,
                allowedRfRegionIds: $event,
              },
            })
          "
        />
        <!-- Допустить к участию иностранных граждан -->
        <BaseSwitcher
          :value="isForeignPeopleAllowed"
          @input="handleForeignPeopleToogle"
        >
          <template slot="label">
            {{ $t('tournaments.settings_foreign-people-label') }}
            <pvp-tooltip>
              <Icon name="info" inline />
              <template slot="tooltip">
                {{
                  $t('tournaments.settings_foreign-people-tooltip')
                }}
              </template>
            </pvp-tooltip>
          </template>
        </BaseSwitcher>
      </div>

      <!-- Влючить проверку по учебным заведениям -->
      <BaseSwitcher
        :value="isEduInfoRequired"
        @input="handleEduInfoToogle"
      >
        <template slot="label">
          Запрос учебного заведения
          <pvp-tooltip>
            <Icon name="info" inline />
            <template slot="tooltip">
              Вы можете установить ограничения по типу учебных
              заведений
            </template>
          </pvp-tooltip>
        </template>
      </BaseSwitcher>
      <!--  -->

      <!-- Спискок разрешенных типов учебных заведений -->
      <BaseSelect
        v-if="isEduInfoRequired"
        class="settings-control"
        :multiple="true"
        value-key="key"
        label-key="name"
        :options="eduTypes"
        :value="allowedEduTypes"
        placeholder="Выберите ограничение по учебному заведению"
        @input="handleAllowedEduTypesSelect"
      />
      <!--  -->
    </template>
  </div>
</template>

<script>
import Icon from '@components/v2/utils/Icon.vue';
import BaseSelect from '@components/BaseComponents/Form/Select.vue';
import BaseSwitcher from '@components/BaseComponents/Form/Switcher.vue';
import BaseInput from '@components/BaseComponents/Form/BaseInput.vue';

export default {
  name: 'PersonalDataSettings',

  components: {
    Icon,
    BaseSwitcher,
    BaseInput,
    BaseSelect,
  },

  data() {
    return {
      eduTypes: [
        {
          key: 'school',
          name: 'Школа',
        },
        {
          key: 'university',
          name: 'Вуз',
        },
      ],
    };
  },

  computed: {
    ...mapState('tournamentSettings', ['form', 'abilities']),
    ...mapGetters('tournamentSettings', [
      'getPDEnabled',
      'getPDSettings',
    ]),
    ...mapGetters('application', ['getRegions']),

    isAccess() {
      const type = typeof this.getPDEnabled;
      return type === 'boolean';
    },

    regions() {
      return this.getRegions;
    },
    minAge() {
      return this.getPDSettings.minAge;
    },
    isRegionRequired() {
      return this.getPDSettings.isRegionRequired;
    },
    isRegionRestrictionEnabled() {
      return this.getPDSettings.isRegionRestrictionEnabled;
    },
    isEduInfoRequired() {
      return this.getPDSettings.isEduInfoRequired;
    },
    allowedEduTypes() {
      return this.getPDSettings.allowedEduTypes;
    },
    allowedRfRegionIds() {
      return this.getPDSettings.allowedRfRegionIds;
    },
    isForeignPeopleAllowed() {
      return this.getPDSettings.isForeignPeopleAllowed;
    },
  },

  methods: {
    ...mapActions('tournamentSettings', ['updateFormData']),

    updatePDSettingByName(name, value) {
      this.updateFormData({
        name: this.form.fksPdV2Settings.name,
        value: {
          ...this.form.fksPdV2Settings.value,
          [name]: value,
        },
      });
    },
    resetPDSettings() {
      this.updateFormData({
        name: this.form.fksPdV2Settings.name,
        value: this.form.fksPdV2Settings.default,
      });
    },

    handlePDSettingsToggle(value) {
      this.updateFormData({
        name: this.form.fksPdV2Enabled.name,
        value,
      });

      if (!value) this.resetPDSettings();
    },
    handleMinAgeInput(inputValue) {
      const numericValue = inputValue.replace(/[^\d]/g, '');
      const number = Number(numericValue);
      const validatedNumber = number > 100 ? 100 : number;
      const minAgeValue =
        validatedNumber > 0 ? validatedNumber : null;
      this.updatePDSettingByName('minAge', minAgeValue);
    },
    handleRegionRequiredToggle(value) {
      this.updatePDSettingByName('isRegionRequired', value);
    },
    handleAllowedRegionToogle(value) {
      this.updatePDSettingByName('isRegionRestrictionEnabled', value);
      this.updatePDSettingByName('isForeignPeopleAllowed', false);
      if (!value) {
        this.updatePDSettingByName('allowedRfRegionIds', null);
      }
    },
    handleEduInfoToogle(value) {
      this.updatePDSettingByName('isEduInfoRequired', value);
    },
    handleAllowedEduTypesSelect(value) {
      if (value.length) {
        this.updatePDSettingByName('allowedEduTypes', value);
      } else {
        this.updatePDSettingByName('allowedEduTypes', null);
      }
    },
    handleForeignPeopleToogle(value) {
      this.updatePDSettingByName('isForeignPeopleAllowed', value);
    },
  },
};
</script>

<style lang="scss" scoped>
.switcher {
  margin-top: 20px;
  display: flex;
}

.select,
.label {
  margin-top: 20px;
}

.toggle-btn {
  display: block;
  margin-top: 20px;
}

.inline-group {
  display: flex;
  align-items: flex-end;
  width: 100%;
  max-width: 420px;

  .select {
    width: 100%;
  }

  .icon {
    flex-shrink: 0;
    margin-left: 8px;
    margin-bottom: 2px;
    font-size: 18px;
  }
}

.indent {
  margin-top: 20px;
}

.pd {
  .select {
    margin-top: 4px;
  }

  &-label {
    color: rgba(white, 0.5);
    font-size: em(14px);
  }
}

.settings-control {
  max-width: 420px;
}

::v-deep .switcher {
  .icon {
    margin-left: 2px;
    margin-bottom: -3px;
  }
}
</style>
